/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Showcase_Rareachievementsdetail2Inputs */

const id_profile_showcase_rareachievementsdetail2 = /** @type {(inputs: Profile_Showcase_Rareachievementsdetail2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pencapaian sulit ditemukan di seluruh profil`)
};

const ms_profile_showcase_rareachievementsdetail2 = /** @type {(inputs: Profile_Showcase_Rareachievementsdetail2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bukaan sukar ditemui di seluruh profil`)
};

const da_profile_showcase_rareachievementsdetail2 = /** @type {(inputs: Profile_Showcase_Rareachievementsdetail2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Svære at finde oplåsninger på tværs af profilen`)
};

const de_profile_showcase_rareachievementsdetail2 = /** @type {(inputs: Profile_Showcase_Rareachievementsdetail2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schwer zu findende Freischaltungen im Profil`)
};

const en_us2_profile_showcase_rareachievementsdetail2 = /** @type {(inputs: Profile_Showcase_Rareachievementsdetail2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hard-to-find unlocks across the profile`)
};

const es_es2_profile_showcase_rareachievementsdetail2 = /** @type {(inputs: Profile_Showcase_Rareachievementsdetail2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desbloqueos difíciles de encontrar en el perfil`)
};

const es_mx2_profile_showcase_rareachievementsdetail2 = /** @type {(inputs: Profile_Showcase_Rareachievementsdetail2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desbloqueos difíciles de encontrar en el perfil`)
};

const fil_profile_showcase_rareachievementsdetail2 = /** @type {(inputs: Profile_Showcase_Rareachievementsdetail2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mahirap makitang mga unlock sa buong profile`)
};

const fr_profile_showcase_rareachievementsdetail2 = /** @type {(inputs: Profile_Showcase_Rareachievementsdetail2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Déblocages difficiles à trouver sur le profil`)
};

const it_profile_showcase_rareachievementsdetail2 = /** @type {(inputs: Profile_Showcase_Rareachievementsdetail2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sblocchi difficili da trovare in tutto il profilo`)
};

const hu_profile_showcase_rareachievementsdetail2 = /** @type {(inputs: Profile_Showcase_Rareachievementsdetail2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nehezen megtalálható feloldások a profilban`)
};

const nl_profile_showcase_rareachievementsdetail2 = /** @type {(inputs: Profile_Showcase_Rareachievementsdetail2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Moeilijk te vinden ontgrendelingen in het profiel`)
};

const no_profile_showcase_rareachievementsdetail2 = /** @type {(inputs: Profile_Showcase_Rareachievementsdetail2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vanskelig å finne opplåsinger på tvers av profilen`)
};

const pl_profile_showcase_rareachievementsdetail2 = /** @type {(inputs: Profile_Showcase_Rareachievementsdetail2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trudne do zdobycia odblokowania w profilu`)
};

const pt_br2_profile_showcase_rareachievementsdetail2 = /** @type {(inputs: Profile_Showcase_Rareachievementsdetail2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desbloqueios difíceis de encontrar em todo o perfil`)
};

const pt_profile_showcase_rareachievementsdetail2 = /** @type {(inputs: Profile_Showcase_Rareachievementsdetail2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desbloqueios difíceis de encontrar no perfil`)
};

const ro_profile_showcase_rareachievementsdetail2 = /** @type {(inputs: Profile_Showcase_Rareachievementsdetail2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deblocări greu de găsit în profil`)
};

const fi_profile_showcase_rareachievementsdetail2 = /** @type {(inputs: Profile_Showcase_Rareachievementsdetail2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vaikeasti löydettävät avaukset profiilissa`)
};

const sv_profile_showcase_rareachievementsdetail2 = /** @type {(inputs: Profile_Showcase_Rareachievementsdetail2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Svårhittade upplåsningar i profilen`)
};

const vi_profile_showcase_rareachievementsdetail2 = /** @type {(inputs: Profile_Showcase_Rareachievementsdetail2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Những mở khóa khó tìm trong hồ sơ`)
};

const tr_profile_showcase_rareachievementsdetail2 = /** @type {(inputs: Profile_Showcase_Rareachievementsdetail2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profilde bulunması zor açılımlar`)
};

const cs_profile_showcase_rareachievementsdetail2 = /** @type {(inputs: Profile_Showcase_Rareachievementsdetail2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Těžko nalezitelné odemčení v profilu`)
};

const bg_profile_showcase_rareachievementsdetail2 = /** @type {(inputs: Profile_Showcase_Rareachievementsdetail2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Трудно откриваеми отключвания в профила`)
};

const ru_profile_showcase_rareachievementsdetail2 = /** @type {(inputs: Profile_Showcase_Rareachievementsdetail2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Трудно получаемые достижения в профиле`)
};

const uk_profile_showcase_rareachievementsdetail2 = /** @type {(inputs: Profile_Showcase_Rareachievementsdetail2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Важкодоступні розблокування в профілі`)
};

const ar_profile_showcase_rareachievementsdetail2 = /** @type {(inputs: Profile_Showcase_Rareachievementsdetail2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`عمليات فتح يصعب العثور عليها عبر الملف الشخصي`)
};

const hi_profile_showcase_rareachievementsdetail2 = /** @type {(inputs: Profile_Showcase_Rareachievementsdetail2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रोफ़ाइल पर मिलने वाली दुर्लभ अनलॉक`)
};

const th_profile_showcase_rareachievementsdetail2 = /** @type {(inputs: Profile_Showcase_Rareachievementsdetail2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`การปลดล็อกที่หายากทั่วโปรไฟล์`)
};

const ja_profile_showcase_rareachievementsdetail2 = /** @type {(inputs: Profile_Showcase_Rareachievementsdetail2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プロフィール全体で見つけにくい解除`)
};

const zh_cn2_profile_showcase_rareachievementsdetail2 = /** @type {(inputs: Profile_Showcase_Rareachievementsdetail2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`档案中难以解锁的成就`)
};

const zh_hant1_profile_showcase_rareachievementsdetail2 = /** @type {(inputs: Profile_Showcase_Rareachievementsdetail2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`檔案中難以解鎖的成就`)
};

const ko_profile_showcase_rareachievementsdetail2 = /** @type {(inputs: Profile_Showcase_Rareachievementsdetail2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`프로필 전반의 찾기 힘든 잠금 해제`)
};

/**
* | output |
* | --- |
* | "Hard-to-find unlocks across the profile" |
*
* @param {Profile_Showcase_Rareachievementsdetail2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const profile_showcase_rareachievementsdetail2 = /** @type {((inputs?: Profile_Showcase_Rareachievementsdetail2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Showcase_Rareachievementsdetail2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_profile_showcase_rareachievementsdetail2(inputs)
	if (locale === "ms") return ms_profile_showcase_rareachievementsdetail2(inputs)
	if (locale === "da") return da_profile_showcase_rareachievementsdetail2(inputs)
	if (locale === "de") return de_profile_showcase_rareachievementsdetail2(inputs)
	if (locale === "en-US") return en_us2_profile_showcase_rareachievementsdetail2(inputs)
	if (locale === "es-ES") return es_es2_profile_showcase_rareachievementsdetail2(inputs)
	if (locale === "es-MX") return es_mx2_profile_showcase_rareachievementsdetail2(inputs)
	if (locale === "fil") return fil_profile_showcase_rareachievementsdetail2(inputs)
	if (locale === "fr") return fr_profile_showcase_rareachievementsdetail2(inputs)
	if (locale === "it") return it_profile_showcase_rareachievementsdetail2(inputs)
	if (locale === "hu") return hu_profile_showcase_rareachievementsdetail2(inputs)
	if (locale === "nl") return nl_profile_showcase_rareachievementsdetail2(inputs)
	if (locale === "no") return no_profile_showcase_rareachievementsdetail2(inputs)
	if (locale === "pl") return pl_profile_showcase_rareachievementsdetail2(inputs)
	if (locale === "pt-BR") return pt_br2_profile_showcase_rareachievementsdetail2(inputs)
	if (locale === "pt") return pt_profile_showcase_rareachievementsdetail2(inputs)
	if (locale === "ro") return ro_profile_showcase_rareachievementsdetail2(inputs)
	if (locale === "fi") return fi_profile_showcase_rareachievementsdetail2(inputs)
	if (locale === "sv") return sv_profile_showcase_rareachievementsdetail2(inputs)
	if (locale === "vi") return vi_profile_showcase_rareachievementsdetail2(inputs)
	if (locale === "tr") return tr_profile_showcase_rareachievementsdetail2(inputs)
	if (locale === "cs") return cs_profile_showcase_rareachievementsdetail2(inputs)
	if (locale === "bg") return bg_profile_showcase_rareachievementsdetail2(inputs)
	if (locale === "ru") return ru_profile_showcase_rareachievementsdetail2(inputs)
	if (locale === "uk") return uk_profile_showcase_rareachievementsdetail2(inputs)
	if (locale === "ar") return ar_profile_showcase_rareachievementsdetail2(inputs)
	if (locale === "hi") return hi_profile_showcase_rareachievementsdetail2(inputs)
	if (locale === "th") return th_profile_showcase_rareachievementsdetail2(inputs)
	if (locale === "ja") return ja_profile_showcase_rareachievementsdetail2(inputs)
	if (locale === "zh-CN") return zh_cn2_profile_showcase_rareachievementsdetail2(inputs)
	if (locale === "zh-Hant") return zh_hant1_profile_showcase_rareachievementsdetail2(inputs)
	return ko_profile_showcase_rareachievementsdetail2(inputs)
});
export { profile_showcase_rareachievementsdetail2 as "profile.showcase.rareAchievementsDetail" }